export default "__VITE_ASSET__BnM$bZyQ__"